import { PreviewType } from '@/pages/campaign/CreatePage/types';
import { AgentStatus } from '@d-id/types';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

const StyledVideo = styled.video<{ preview?: PreviewType; show?: boolean }>`
    border-radius: 6px;
    position: absolute;
    top: 0;
    left: 0;
    height: ${({ preview }) => (preview === PreviewType.DESKTOP ? '512px' : '100%')};
    width: ${({ preview }) => (preview === PreviewType.DESKTOP ? '512px' : '100%')};
    object-fit: cover;
    z-index: ${({ show }) => (show ? 10 : 0)};
`;

const StyledImage = styled.img<{ show: boolean; preview?: PreviewType }>`
    display: ${({ show }) => (show ? 'block' : 'none')};
    z-index: ${({ show }) => (show ? 10 : 0)};
    border-radius: 6px;
    position: absolute;
    top: 50%;
    left: 50%;
    height: ${({ preview }) => (preview === PreviewType.DESKTOP ? '512px' : '100%')};
    width: ${({ preview }) => (preview === PreviewType.DESKTOP ? '512px' : '100%')};
    transform: translate(-50%, -50%);
    object-fit: cover;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%), white;
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 20;
    border-radius: 6px;
`;

interface Props {
    idleVideo?: string;
    preview?: PreviewType;
    thumbnail?: string;
    show: boolean;
    speakLoading: boolean;
    agentStatus: AgentStatus;
}
export const IdleComponent = ({ idleVideo, preview, thumbnail, show, speakLoading, agentStatus }: Props) => {
    if (!show) {
        return null;
    }

    // When agent is done, the newest idle video is ready
    if (idleVideo && agentStatus === AgentStatus.Done) {
        return (
            <>
                {speakLoading && <Overlay />}
                <StyledVideo src={idleVideo} muted autoPlay playsInline preview={preview} show loop />
            </>
        );
    }

    if (thumbnail) {
        return (
            <>
                {speakLoading && <Overlay />}
                <StyledImage src={thumbnail} alt="Agent" show preview={preview} />
            </>
        );
    }

    return <Skeleton variant="rounded" width="100%" height="100%" />;
};
